import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    standalone: false
})
export class ButtonComponent {
  @Input() btnType: string;
  @Input() class: string;
  @Input() isImageClass: string;
  @Input() disabled: boolean;
  @Input() innerText:string;
  @Input() buttonIconBeforeTextPath:string
  @Input() buttonIconBeforeTextCss:string
  @Input() buttonIconAfterTextPath:string
  @Input() buttonIconAfterTextCss:string
  @Input() onlyImagePath:string
  @Input() isSvg:boolean
  @Input() isImage:boolean
  @Output() buttonClick: EventEmitter<any> = new EventEmitter();
  @Output() change: EventEmitter<boolean> = new EventEmitter<boolean>();

  
  clickMethod() {
    this.buttonClick.emit(true);
  }

  changeMethod(){
    this.change.emit(true);
  }
}
